import React from "react";
import FooterSocialLink from "./FooterSocialLink";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="container-fluid p-0 footer">
      <div className="row app-container justify-content-between footer-row">
        {/* Company Details Start */}
        <div className="col-md-4 col-12 mb-md-0 mb-4 company-details">
          <h4 className="mb-3">Hotelbnb</h4>
          <p className="pe-lg-4 pe-md-0 pe-sm-5 pe-0">
            Every Stay Feels Like Home Away From Home - Elevate Your Travel
            Experience with Seamless Booking and Unmatched Hospitality.
          </p>
        </div>
        {/* Company Details End */}

        {/* Footer Links Start */}
        <div className="col-md-3 col-sm-5 col-12 mb-sm-0 mb-4 footer-links ps-lg-4">
          <h5 className="mb-3">Quick Links</h5>
          <p className="m-0">
            <Link to="/about-us">About</Link>
          </p>
          <p className="m-0">
            <Link to="/support">Support</Link>
          </p>
          <p className="m-0">
            <Link to="/support/#support-faq-section">FAQs</Link>
          </p>
          <p className="m-0">
            <Link to="/my-account">My Account</Link>
          </p>
          <p className="mb-sm-0">
            <Link to="/my-bookings">My Bookings</Link>
          </p>
        </div>
        {/* Footer Links End */}

        {/* Our Socials Start */}
        <div className="col-md-3 col-sm-5 col-12 footer-socials">
          <h5 className="mb-3">Our Socials</h5>
          <FooterSocialLink link="#" icon="fa-facebook" label="Facebook" />
          <FooterSocialLink link="#" icon="fa-instagram" label="Instagram" />
          <FooterSocialLink link="#" icon="fa-twitter" label="Twitter" />
        </div>
        {/* Our Socials End */}
      </div>

      {/* Footer Bottom Start */}
      <div className="row app-container footer-bottom">
        <p className="text-center my-3">
          © 2023 Hotelbnb. All rights reserved | <a className="text-decoration-none custom-anchor" href="https://github.com/adilcodes" target="_blank">Made By Adil Sheikh</a>
        </p>
      </div>
      {/* Footer Bottom End */}
    </div>
  );
}
